const brand =
  window.location.host && window.location.host.includes('drtis.com')
    ? 'human'
    : 'vet';

export default brand;
